import { Ajax } from './Ajax';

export class FieldValidation {
  constructor() {
    this.cancelAsync = () => { };
    this.currentValue = '';
    this.validatedValue = '';
    this.isValid = true;
  }

  async valid(value, url) {
    if (!value) return true;

    this.currentValue = value;

    if (value === this.validatedValue) {
      return this.isValid;
    }

    if (value !== this.currentValue) {
      return true;
    }

    if (this.cancelAsync) {
      this.cancelAsync();
      this.cancelAsync = null;
    }

    const { data: isValid } = await Ajax.get(url, {
      cancelToken: new Ajax.CancelToken(cancel => {
        this.cancelAsync = cancel;
      }),
    });

    this.validatedValue = value;

    switch (typeof isValid) {
      case 'boolean':
        this.isValid = isValid;
        break;
      case 'string':
        this.isValid = !isValid;
        break;
      default:
        this.isValid = true;
    }

    return this.isValid;
  }
}
